/**
 * Commercial-kind helpers for the shared affiliate/partner portal.
 *
 * `commercial_kind` comes from the backend on `GET /api/influencer/check/`
 * (inside the `user` object) and decides the portal VIEW. The URL prefix
 * (`/affiliate` vs `/partner`) is purely cosmetic — the two are interchangeable
 * aliases and users are never redirected between them based on kind.
 */

export const PARTNER_KIND = "partner";

export const isPartnerKind = (user) => user?.commercial_kind === PARTNER_KIND;

/** Base path helpers — keep users on the prefix they entered with. */
export const AFFILIATE_BASE_PATH = "/affiliate";
export const PARTNER_BASE_PATH = "/partner";

export const getPortalBasePath = (pathname) =>
  String(pathname || "").startsWith(PARTNER_BASE_PATH) ? PARTNER_BASE_PATH : AFFILIATE_BASE_PATH;
